import React from 'react';
import Container from 'brastrap/common/container/Container';
import Locate from 'brastrap/containers/locate/LocateContainer';

const LocateContainer = ({
  id,
  location,
  modifiers,
  onBrowse,
  onSubmit,
  title,
}) => (
  <Container {...{ id, modifiers, title }}>
    <Locate {...{ location, onBrowse, modifiers, onSubmit }} />
  </Container>
);

LocateContainer.propTypes = {
  ...Container.propTypes,
  ...Locate.propTypes,
};

LocateContainer.defaultProps = {
  id: 'locate',
};

export default LocateContainer;
